import styled from "styled-components";

export const CardStyled = styled.div`
	background-color: #fff;
	border-radius: 1.6em;
	padding: 1.8em;
	box-shadow: 0 0.8083em 0.8083em rgba(0, 0, 0, 0.1);
	width: 22.4em;
	display: grid;
	grid-template-rows: max-content;
	gap: 1em;
	text-align: center;

	&.landscape {
		width: 24.85em;
	}

	&.mobile {
		height: 24em;

		.body {
			display: flex;
			flex-direction: column;
			gap: 0.2rem;
		}

		.description {
			width: auto;
		}
	}
`;

export const Img = styled.img`
	width: 100%;
	height: auto;
	object-fit: cover;
	border-radius: 1.6em;
`;

export const Title = styled.h3`
	font-family: "Baloo";
	font-size: 2em;
	font-weight: 400;
	line-height: 1em;
	color: #113b62;
	margin: 0;
`;

export const Description = styled.p`
	font-size: 1.2em;
	line-height: 1.1666em;
	font-weight: 400;
	width: 19.45em;
	margin: 0 auto;
`;
